module.exports = __webpack_public_path__ + "static/media/backVideoR.7e49fa60.mp4";